import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-0.1 -0.1 7.2 7.2",
	fill: "none",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.533927 0.0689541L3.49684 3.02968L6.42828 0.0986793C6.62806 -0.0792355 6.83482 0.0269889 6.91744 0.116165C6.97044 0.180745 6.99777 0.262591 6.99423 0.346056C6.99068 0.429522 6.95649 0.508752 6.89821 0.568602L3.96633 3.49917L6.89821 6.42886C7.02847 6.53815 7.02847 6.75234 6.924 6.87212C6.81909 6.99146 6.62675 7.06053 6.44533 6.91889L3.49684 3.96865L0.544856 6.92021C0.415463 7.03605 0.20214 7.01244 0.09679 6.89747C-0.00899719 6.78207 -0.0492138 6.58274 0.0858615 6.44198L3.02736 3.49917L0.0981013 0.568602C-0.00899729 0.450575 -0.046154 0.234629 0.0981013 0.0986793C0.242357 -0.0372703 0.457428 -0.0184734 0.533927 0.0689541Z",
		fill: "currentColor"
	})
});
export default SvgCloseSmall;
